module.exports = __webpack_public_path__ + "img/Microsoft-Teams.4ae9f793.png";